module.exports = __webpack_public_path__ + "h5/img/logo.0eb4267b.png";